export const TYPE_KEY = Symbol('resourceType');

export function typeAs(type) {
  return (item) => {
    item[TYPE_KEY] = type;
    return item;
  };
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
